export default "__VITE_ASSET__c4e91a19__"